import { Box } from "@mui/material";
import { observer } from "mobx-react-lite";
import React, { Children, FunctionComponent, PropsWithChildren } from "react";

const boxSx = (props: CssColumnGridProps) => {
	return {
		display: "grid",
		gap: 4,
		gridTemplateColumns: `repeat(${props.columns}, 1fr)`,
	};
};

export interface CssColumnGridProps extends PropsWithChildren {
	centerContent?: boolean;
	columns: number;
}

const CssColumnGrid: FunctionComponent<CssColumnGridProps> = observer((props) => {
	const { centerContent, children } = props;
	const centerStyles = {
		display: "flex",
		justifyContent: "center",
	};

	return (
		<Box sx={boxSx(props)}>
			{
				Children.map(children, (Child) => (
					<Box sx={centerContent ? centerStyles : null}>
						{Child}
					</Box>
				))
			}
		</Box>
	);
});

export default CssColumnGrid;